"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _each = _interopRequireDefault(require("lodash/each"));

var _jquery = _interopRequireDefault(require("jquery"));

var NodeFilter = typeof window !== 'undefined' ? window.NodeFilter : {}; // special cases: menus, popups etc.

var specials = [{
  targetClass: 'profile--dropdown-trigger',
  elements: '.main-navigation--profile-link .dropdown'
}]; // elements whose click event should be hijacked

var hijacks = ['.js-cancel-crop', '.js-save-crop', '.js-menu-dropdown-toggle'];

var DocumentParser = /*#__PURE__*/function () {
  function DocumentParser() {
    (0, _classCallCheck2.default)(this, DocumentParser);
  }

  (0, _createClass2.default)(DocumentParser, [{
    key: "init",
    value: function init(onPhraseGetStart, onPhraseGetEnd, onTranslateEnd) {
      var self = this;
      this.associated = {};
      this.onPhraseGetStart = onPhraseGetStart;
      this.onPhraseGetEnd = onPhraseGetEnd;
      this.onTranslateEnd = onTranslateEnd; // deal with multiple ajax calls

      var debounceParse = (0, _debounce.default)(function () {
        self.prepareDoc();
      }, 1000).bind(this); // re-parse after ajax operations

      (0, _jquery.default)(document).ajaxComplete(function (event, xhr, options) {
        if (!/\/phrase\//.test(options.url)) {
          debounceParse();
        }
      }); // if no ajax calls occur:

      debounceParse();
    }
  }, {
    key: "exit",
    value: function exit() {
      document.removeEventListener('click', this.handleClick);
      document.body.classList.remove('page-loading');
    }
  }, {
    key: "enableDropdownLinks",
    value: function enableDropdownLinks() {
      var _this = this;

      // phrase-enable popups
      var pops = document.querySelectorAll('.dropdown, .dropdown-links__item-link');
      (0, _each.default)(pops, function (pop) {
        pop.removeEventListener('click', _this.handleClick.bind(_this));
        pop.addEventListener('click', _this.handleClick.bind(_this));
      });
    }
  }, {
    key: "enableAvatarModal",
    value: function enableAvatarModal() {
      // show avatar upload modal
      var avatarUploader = document.querySelector('.js-avatar-uploader .is-hidden');

      if (avatarUploader) {
        avatarUploader.classList.remove('is-hidden');
        avatarUploader.classList.add('mfp-content');
      }
    }
  }, {
    key: "prepareDoc",
    value: function prepareDoc() {
      this.parse();
      this.enableDropdownLinks();
      this.enableAvatarModal();
      setTimeout(function () {
        document.body.classList.remove('page-loading');
      }, 500);
    } // get (latest) phrase data.

  }, {
    key: "getTranslation",
    value: function getTranslation(key) {
      var _this2 = this;

      var data = key.split('--');
      this.onPhraseGetStart();

      _jquery.default.get('/phrase/item', {
        category: data[0],
        message: data[1],
        params: data[2],
        key: key
      }, function (data) {
        _this2.onPhraseGetEnd(data);
      });
    } // click on document: if phrase then retrieve associated phrase data

  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this3 = this;

      var target = e.target;
      var self = this; // special case: button

      if (target.tagName === 'BUTTON') {
        target = target.querySelector('.js-phrase');
      }

      if (!target) return; // selectize click

      if (target.classList.contains('selectize-input')) {
        this.parse(target.parentNode);
      } // selectize option click


      if (target.parentNode.classList.contains('option')) {
        setTimeout(function () {
          self.parse(target.parentNode.parentNode.parentNode.parentNode);
        }, 300);
      } // other special cases (popup menus and the like)


      var elements = this.associated.elements;

      if (elements) {
        elements = document.querySelector(elements);

        if (elements && !elements.contains(target)) {
          elements.classList.add('is-hidden');
          this.associated = {};
        }
      } // halt events


      if (target.classList.contains('js-phrase') || target.parentNode.classList.contains('js-phrase')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      } // regular behaviour: translate phrase


      if (target.classList.contains('js-phrase')) {
        var attributeData = target.parentNode.hasAttribute('data-translationkey') ? target.parentNode.getAttribute('data-translationkey') : target.parentNode.querySelector('.js-phrase_placeholder').getAttribute('data-translationkey');
        this.getTranslation(attributeData);
      } // take care of special cases


      specials.forEach(function (special) {
        if (target.parentNode.classList.contains(special.targetClass)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          _this3.associated = special;
          document.querySelector(_this3.associated.elements).classList.remove('is-hidden');

          if (special.phrase) {
            _this3.getTranslation(document.querySelector(special.phrase).getAttribute('data-translationkey'));
          }
        }
      });
    } // submit new/ updated phrase

  }, {
    key: "translate",
    value: function translate(query) {
      var _this4 = this;

      var affected = document.querySelectorAll('*[data-translationkey^="' + query.category + '--' + query.message + '"]');

      _jquery.default.get('/phrase/edit', query, function (data) {
        // update all affected phrases in dom
        (0, _each.default)(affected, function (item) {
          var param = item.getAttribute('data-translationparam');
          var translation = data.translation;
          /* translate on the fly: */
          // 1) translate variable's value

          if (param && param.length) {
            param = param.split(',');
            translation = translation.replace(param[0], param[1]); // 2) translate singular/ plural
          } else {
            var dual = translation.split('|');

            if (dual.length > 1) {
              var number = parseInt(item.innerHTML.replace(/\D/g, ''), 10);

              if (number === 1) {
                translation = dual[0].replace(/\{.+\}/, 1);
              } else {
                translation = dual[1].replace(/\{.+\}/, number);
              }
            }
          }

          if (item.hasAttribute('placeholder')) {
            var icon = item.classList.contains('bigsearch-input') ? item.getAttribute('placeholder').charAt(0) + ' ' : '';
            item.setAttribute('placeholder', icon + translation);
          } else if (item.hasAttribute('data-placeholder')) {
            item.setAttribute('data-placeholder', translation);
          } else {
            item.innerHTML = translation + '<span class="js-phrase js-phrase_edit-btn">edit</span>';
          }
        });

        _this4.onTranslateEnd(data);
      });
    }
  }, {
    key: "toggleHijacks",
    value: function toggleHijacks(on) {
      var _this5 = this;

      (0, _each.default)(hijacks, function (item) {
        var el = document.querySelector(item);

        if (el) {
          if (on) {
            el.addEventListener('click', _this5.handleClick.bind(_this5));
          } else {
            el.removeEventListener('click', _this5.handleClick.bind(_this5));
          }
        }
      });
    }
  }, {
    key: "toggleListeners",
    value: function toggleListeners(on) {
      var _this6 = this;

      if (on) {
        document.addEventListener('click', this.handleClick.bind(this), {
          capture: true
        });
        (0, _each.default)(document.querySelectorAll('.selectize-dropdown .js-phrase'), function (item) {
          return item.addEventListener('mousedown', _this6.handleClick.bind(_this6));
        });
      } else {
        document.removeEventListener('click', this.handleClick.bind(this));
        (0, _each.default)(document.querySelectorAll('.selectize-dropdown .js-phrase'), function (item) {
          return item.removeEventListener('mousedown', _this6.handleClick.bind(_this6));
        });
      }

      this.toggleHijacks(on);
    } // parse whole document

  }, {
    key: "parse",
    value: function parse() {
      var _this7 = this;

      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var walker;
      var nodes = [];
      var item;
      this.toggleListeners(false); // disable (most) attribute editing for now (re-inserting regular phrase value)
      // just placeholder editing allowed

      walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, null, false);

      while (walker.nextNode()) {
        Array.from(walker.currentNode.attributes).forEach(function (att) {
          var val = att.nodeValue;

          if (att.nodeName === 'placeholder' || att.nodeName === 'data-placeholder') {
            try {
              var editBtn = document.createElement('span');
              editBtn.className = 'js-phrase js-phrase_edit-btn';
              editBtn.innerHTML = 'edit';
              var vals = /(\s*)(.*)::phrase::(.*)::phrase::(.*)(\s*)/.exec(val.replace(/\n/g, ' '));
              walker.currentNode.setAttribute('data-translationkey', _this7.getData(vals[3]));
              walker.currentNode.classList.add('js-phrase_placeholder');
              walker.currentNode.parentNode.classList.add('js-phrase-container');
              walker.currentNode.parentNode.appendChild(editBtn);
            } catch (err) {// console.log('failed to set attribute on', walker.currentNode)
            }
          }

          att.nodeValue = val.replace(/\n/g, ' ').replace(/::phrase::.*::phrase::/, _this7.getData(val, 2));
        });
      } // get all phrase text nodes


      walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, function (item) {
        if (item.nodeValue.replace(/\n/g, ' ').match(/::phrase::.*::phrase::/) && item.parentNode.tagName !== 'SCRIPT') {
          return NodeFilter.FILTER_ACCEPT;
        }
      }, false);

      while (item = walker.nextNode()) {
        nodes.push(item);
      } // transform phrase text nodes


      nodes.forEach(function (item) {
        var val = /(\s*)(.*)::phrase::(.*)::phrase::(.*)(\s*)/.exec(item.nodeValue.replace(/\n/g, ' '));
        var txt = val[2] + '<span data-translationkey="' + _this7.getData(val[3]) + '" data-translationparam="' + _this7.getData(val[3], 3) + '">' + _this7.getData(val[3], 2) + '' + '<span class="js-phrase js-phrase_edit-btn">edit</span>' + '</span>' + val[4];
        if (item.parentNode) item.parentNode.innerHTML = txt;
      });
      this.toggleListeners(true);
    } // get appropriate phrase data

  }, {
    key: "getData",
    value: function getData(phrase, index) {
      var ret = phrase.replace(/\n/g, ' ').replace(/::phrase::/g, '');

      if (index) {
        ret = ret.split('--');

        if (ret[index]) {
          return ret[index];
        }

        return '';
      }

      return ret.trim();
    }
  }]);
  return DocumentParser;
}();

var _default = new DocumentParser();

exports.default = _default;